/* Zhukov's wishlist client — replaces Smart Wishlist. Talks to the app
   proxy at /apps/tools/wishlist (Shopify-signed; customer identity comes
   from the session server-side, never from this script). */
(function () {
  var API = '/apps/tools/wishlist';
  var TOKEN_KEY = 'za_wl_token';
  var CLAIM_KEY = 'za_wl_claimed_v1';
  var state = null; // Set of productIds
  var pending = null;

  function token() {
    var t = null;
    try { t = localStorage.getItem(TOKEN_KEY); } catch (e) {}
    if (!t) {
      t = 'za' + Math.random().toString(36).slice(2) + Date.now().toString(36);
      try { localStorage.setItem(TOKEN_KEY, t); } catch (e) {}
    }
    return t;
  }

  function api(method, body) {
    var url = API + '?guest=' + encodeURIComponent(token());
    return fetch(url, {
      method: method,
      headers: body ? { 'Content-Type': 'application/json' } : undefined,
      body: body ? JSON.stringify(body) : undefined,
    }).then(function (r) { return r.json(); });
  }

  /* Old Smart Wishlist guest tokens hide in localStorage/cookies under
     various keys — collect anything plausible so imported express lists
     get claimed. Harmless if nothing matches. */
  function foreignTokens() {
    var out = [];
    var plausible = /^[0-9]{6,12}[a-z0-9]{4,30}$/i;
    try {
      for (var i = 0; i < localStorage.length; i++) {
        var k = localStorage.key(i);
        if (!/wish|swl|smart/i.test(k)) continue;
        var v = (localStorage.getItem(k) || '').replace(/^"|"$/g, '');
        if (plausible.test(v)) out.push(v);
      }
    } catch (e) {}
    (document.cookie || '').split(';').forEach(function (c) {
      var kv = c.trim().split('=');
      if (kv.length === 2 && /wish|swl|smart/i.test(kv[0]) && plausible.test(kv[1])) out.push(kv[1]);
    });
    return out.slice(0, 5);
  }

  function load() {
    if (pending) return pending;
    pending = api('GET').then(function (d) {
      state = new Set((d.items || []).map(function (i) { return String(i.productId); }));
      paintAll();
      return state;
    }).catch(function () { state = new Set(); return state; });
    return pending;
  }

  function claimOnce() {
    var done = null;
    try { done = sessionStorage.getItem(CLAIM_KEY); } catch (e) {}
    if (done) return;
    var tokens = foreignTokens();
    var loggedIn = Boolean(window.ZA_WL_CUSTOMER);
    if (!loggedIn && tokens.length === 0) return;
    api('POST', { intent: 'claim', tokens: tokens }).then(function (d) {
      try { sessionStorage.setItem(CLAIM_KEY, '1'); } catch (e) {}
      if (d && d.items) {
        state = new Set(d.items.map(function (i) { return String(i.productId); }));
        paintAll();
      }
    }).catch(function () {});
  }

  function paint(btn) {
    if (!state) return;
    var id = btn.getAttribute('data-za-wl-product');
    var on = state.has(String(id));
    btn.classList.toggle('za-wl-on', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var label = btn.querySelector('.za-wl-label');
    if (label) label.textContent = on ? btn.getAttribute('data-za-wl-saved-text') : btn.getAttribute('data-za-wl-add-text');
  }

  function paintAll() {
    document.querySelectorAll('[data-za-wl-product]').forEach(paint);
    var c = document.querySelector('.za-wl-fab-count');
    if (c && state) {
      c.textContent = String(state.size);
      c.style.display = state.size ? '' : 'none';
    }
  }

  function toggle(btn) {
    var id = String(btn.getAttribute('data-za-wl-product'));
    if (!state) return;
    var on = state.has(id);
    if (on) state.delete(id); else state.add(id);
    paint(btn);
    api('POST', {
      intent: on ? 'remove' : 'add',
      productId: id,
      title: btn.getAttribute('data-za-wl-title') || '',
      handle: btn.getAttribute('data-za-wl-handle') || '',
    }).then(function (d) {
      if (d && d.items) {
        state = new Set(d.items.map(function (i) { return String(i.productId); }));
        paintAll();
      }
    }).catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-za-wl-product]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn);
  }, true);

  /* ---------------- Wishlist page ---------------- */
  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function renderPage(root) {
    load().then(function () {
      api('GET').then(function (d) {
        var items = d.items || [];
        root.innerHTML = '';
        if (!d.loggedIn) {
          var hint = document.createElement('p');
          hint.className = 'za-wl-hint';
          hint.innerHTML = 'You’re browsing as a guest — <a href="/account/login">sign in</a> and your wishlist follows your account on every device.';
          root.appendChild(hint);
        }
        if (items.length === 0) {
          var empty = document.createElement('p');
          empty.className = 'za-wl-empty';
          empty.textContent = 'Nothing saved yet — tap the heart on any item to keep it here.';
          root.appendChild(empty);
          return;
        }
        var grid = document.createElement('div');
        grid.className = 'za-wl-grid';
        root.appendChild(grid);
        var queue = items.slice();
        var active = 0;
        function next() {
          while (active < 5 && queue.length) {
            active++;
            var item = queue.shift();
            (function (item) {
              var card = document.createElement('div');
              card.className = 'za-wl-card';
              grid.appendChild(card);
              fetch('/products/' + item.handle + '.js')
                .then(function (r) { if (!r.ok) throw new Error('gone'); return r.json(); })
                .then(function (prod) {
                  var img = (prod.featured_image || (prod.images && prod.images[0]) || '');
                  card.innerHTML =
                    '<a href="/products/' + prod.handle + '" class="za-wl-card-media">' +
                    (img ? '<img loading="lazy" src="' + img + '&width=480" alt="">' : '') +
                    '</a>' +
                    '<div class="za-wl-card-info">' +
                    '<a href="/products/' + prod.handle + '" class="za-wl-card-title">' + prod.title + '</a>' +
                    '<div class="za-wl-card-price">' + money(prod.price) +
                    (prod.available ? '' : ' <span class="za-wl-badge">Out of stock</span>') + '</div>' +
                    '<button class="za-wl-remove" data-za-wl-remove="' + item.productId + '">Remove</button>' +
                    '</div>';
                })
                .catch(function () {
                  card.innerHTML =
                    '<div class="za-wl-card-info">' +
                    '<span class="za-wl-card-title">' + (item.title || 'Saved item') + '</span>' +
                    '<div class="za-wl-card-price"><span class="za-wl-badge">Currently unavailable</span></div>' +
                    '<button class="za-wl-remove" data-za-wl-remove="' + item.productId + '">Remove</button>' +
                    '</div>';
                })
                .then(function () { active--; next(); });
            })(item);
          }
        }
        next();
        grid.addEventListener('click', function (e) {
          var b = e.target.closest('[data-za-wl-remove]');
          if (!b) return;
          var id = String(b.getAttribute('data-za-wl-remove'));
          state && state.delete(id);
          api('POST', { intent: 'remove', productId: id });
          var card = b.closest('.za-wl-card');
          if (card) card.remove();
        });
      });
    });
  }

  /* Floating side tab — replaces Smart Wishlist's. */
  function mountFab() {
    if (location.pathname.indexOf('/pages/wishlist') === 0) return;
    var a = document.createElement('a');
    a.href = '/pages/wishlist';
    a.className = 'za-wl-fab';
    a.setAttribute('aria-label', 'My Wishlist');
    a.innerHTML = '<svg class="za-wl-heart" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M12 21s-7.5-4.9-10-9.2C.4 8.6 2 5 5.5 5c2 0 3.4 1.1 4.2 2.5L12 10l2.3-2.5C15.1 6.1 16.5 5 18.5 5 22 5 23.6 8.6 22 11.8 19.5 16.1 12 21 12 21z"/></svg><span class="za-wl-fab-text">Wishlist</span><span class="za-wl-fab-count" style="display:none"></span>';
    document.body.appendChild(a);
  }

  document.addEventListener('DOMContentLoaded', function () {
    mountFab();
    load();
    claimOnce();
    var root = document.getElementById('za-wishlist-root');
    if (root) renderPage(root);
  });
})();
